export default Object.freeze({
  Web: 1,
  Mobile: 2,
  WebMobile: 3,
});
